module.exports = __webpack_public_path__ + "img/xxzx@2x.84bc8de1.png";